<table class="table table-hover" [class.dim]="!crud.complete">
    <thead>
        <tr>
            <th>Permit(s)</th>
            <th>Status</th>
            <th>{{ isCompletedTabActive ? 'Completed At' : 'Date Created' }}</th>
            <th>Ordered By</th>
            <th>Line item total</th>
            <th>Fees</th>
            <th>Total</th>
            <th class="text-end">Actions</th>
        </tr>
    </thead>
    @if (response) {
        <tbody>
            @for (item of response.data; track crud.trackById($index, item)) {
                <ngxh6-offline-indicator [model]="item"></ngxh6-offline-indicator>
                <tr>
                    <!-- Permit number, not the internal order id (TLC, 30 Sep). Staff
                         recognise a permit by its number; each links to the permit. A
                         payment can cover more than one permit, and an assessed permit
                         has no number until it is approved - shown as "Not issued yet". -->
                    <td>
                        @if (item.permitRefs?.length) {
                            @for (ref of item.permitRefs; track $index) {
                                @if (ref.number && ref.id) {
                                    <a [routerLink]="'/crm/permits/' + ref.id">{{ ref.number }}</a>
                                } @else if (ref.number) {
                                    {{ ref.number }}
                                } @else {
                                    <span class="text-muted fst-italic">Not issued yet</span>
                                }@if (!$last) {<span>, </span>}
                            }
                        } @else {
                            <span class="text-muted">-</span>
                        }
                    </td>
                    <!-- Paid / unpaid at a glance, without opening the payment (TLC, 30 Sep). -->
                    <td>
                        @if (item.refunded) {
                            <span class="badge text-bg-secondary">Refunded</span>
                        } @else if (item.fullyPaid) {
                            <span class="badge text-bg-success">Paid</span>
                        } @else if (+(item.amountPaid || '0') > 0) {
                            <span class="badge text-bg-warning">Part-paid</span>
                        } @else {
                            <span class="badge text-bg-light border text-danger">Unpaid</span>
                        }
                    </td>
                    <td>
                        {{
                            isCompletedTabActive
                                ? item.dateCompleted
                                    ? (item.dateCompleted | date: 'medium')
                                    : 'N/A'
                                : item.created
                                  ? (item.created | date: 'medium')
                                  : 'N/A'
                        }}
                    </td>
                    <td>
                        <a [routerLink]="'/crm/users/' + item.userAccount.id">{{ item.userAccount.fullName }}</a>
                    </td>
                    <td>{{ item.lineItemTotal ? (item.lineItemTotal | currency: 'AUD') : '-' }}</td>
                    <td>{{ item.fees ? (item.fees | currency: 'AUD') : '-' }}</td>
                    <td>{{ item.total ? (item.total | currency: 'AUD') : '-' }}</td>
                    <td class="text-end col-2">
                        <div class="d-flex align-items-end justify-content-end">
                            @if (item.stripePaymentIntent) {
                                <a
                                    class="btn btn-primary me-1"
                                    href="https://dashboard.stripe.com/payments/{{ item.stripePaymentIntent }}"
                                    title="Stripe reference"
                                    target="_blank"
                                    ><i class="fa fa-credit-card"><i></i></i
                                ></a>
                            }
                            <div class="ms-2 btn-group" ngbDropdown container="body">
                                <a class="btn btn-gray" [routerLink]="'' + item.id">View</a>
                                <button class="btn btn-gray" ngbDropdownToggle></button>
                                <div class="dropdown-menu" ngbDropdownMenu>
                                    <button class="dropdown-item" (click)="crud.modals.form(opts.formSlug, item.id, item)">
                                        <i class="fa fa-fw fa-pencil me-3"></i>Quick Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    }
    @if (!response) {
        <tbody table-loader [cols]="8" [error]="error"></tbody>
    }
</table>
@if (response && !response?.data?.length) {
    <small class="my-4 text-muted"> No Orders to show. </small>
}
